import DefaultProps from '../../commonTypes/defaultprops.types';
import React from 'react';
import { MarkdownHTMLOverrides } from './markdown.types';
import { parseMarkdown } from './parser';

type MarkdownProps = {
  className?: string;
  children: string;
  dataAttr?: DefaultProps['dataAttr'];
  overrides?: MarkdownHTMLOverrides;
};

const DEFAULT_DATA_ATTR = { 'data-testid': 'markdown' };

const Markdown = ({ className, children, dataAttr = {}, overrides }: MarkdownProps) => {
  if (!children || typeof children !== 'string') {
    return null;
  }
  const htmlProp = {
    __html: parseMarkdown(children, overrides),
  };

  const combinedDataAttr = { ...DEFAULT_DATA_ATTR, ...dataAttr };
  return <div className={className} {...combinedDataAttr} dangerouslySetInnerHTML={htmlProp} />;
};

export default Markdown;
export { parseMarkdown };
